
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"17","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.087 5.703a.968.968 0 01-1.328-.039L5.649 3.36v13.204c0 .546-.43.937-.937.937-.547 0-.937-.39-.937-.938V3.36L1.626 5.664a.915.915 0 01-.664.274 1.06 1.06 0 01-.664-.235c-.39-.351-.39-.937-.039-1.328L4.009.312c.352-.39 1.016-.39 1.367 0l3.75 4.063c.352.39.352.977-.039 1.328zm7.5 6.133c.39.351.39.937-.039 1.328l-3.71 4.063c-.352.39-1.016.39-1.368 0l-3.711-4.063c-.352-.39-.352-.976.039-1.328.195-.156.43-.234.664-.234.234 0 .469.078.664.273l2.149 2.305V.977c0-.547.39-.977.937-.977.508 0 .938.43.938.977V14.18l2.109-2.305a.968.968 0 011.328-.04z","fill":"#fff"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      